import { render, staticRenderFns } from "./AVPlayer2.vue?vue&type=template&id=5bfe406a&scoped=true&lang=pug&"
import script from "./AVPlayer2.vue?vue&type=script&lang=js&"
export * from "./AVPlayer2.vue?vue&type=script&lang=js&"
import style0 from "./AVPlayer2.vue?vue&type=style&index=0&id=5bfe406a&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5bfe406a",
  null
  
)

export default component.exports